/**
 * All Simples — no tile anywhere in the hand is a terminal (rank 1 or 9) or
 * an honor. Pure tile-kind scan across every tile the hand actually
 * contains; no meld-structure needed, so no decomposition either.
 */

import type { TileKind } from '../../game/types.js';
import type { MatchedPattern, ScoringContext } from '../types.js';

const ALL_SIMPLES_VALUE = 1;
const SIMPLE_RANK_MIN = 2;
const SIMPLE_RANK_MAX = 8;

function isSimpleKind(kind: TileKind): boolean {
  return kind.kind === 'suit' && kind.rank >= SIMPLE_RANK_MIN && kind.rank <= SIMPLE_RANK_MAX;
}

export function matchAllSimples(context: ScoringContext): MatchedPattern | null {
  const allTiles = [
    ...context.concealedTiles,
    ...context.melds.flatMap((meldEntry) => meldEntry.tiles),
    context.winningTile,
  ];
  const everySimple = allTiles.every((tile) => isSimpleKind(tile));
  return everySimple ? { name: 'allSimples', kind: 'double', value: ALL_SIMPLES_VALUE } : null;
}
